var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultSeatFreeOnePartBooked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 19C37.5 8.77621 29.2238 0.5 19 0.5C8.77621 0.5 0.5 8.77621 0.5 19C0.5 26.164 4.56976 32.3971 10.5224 35.4743C13.8336 37.186 15.5339 38.648 16.5608 39.6709C16.8127 39.9219 17.0257 40.1481 17.2173 40.3516L17.2339 40.3691C17.4264 40.5735 17.6054 40.7634 17.7737 40.9206C18.1102 41.2351 18.4859 41.5 19 41.5C19.5142 41.5 19.8907 41.2345 20.2281 40.9197C20.397 40.7621 20.5768 40.5719 20.7701 40.367L20.7878 40.3483C20.98 40.1446 21.1935 39.9183 21.4459 39.6673C22.4763 38.6421 24.1801 37.1782 27.4913 35.4665C33.4444 32.3891 37.5 26.1636 37.5 19Z",
    fill: "#1BD665",
    stroke: "#E8FBF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 13,
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSeatFreeOnePartBooked);
export default __webpack_public_path__ + "static/media/default-seat-free-one-part-booked.7226b512bae4b6e292e313b43c60914d.svg";
export { ForwardRef as ReactComponent };